/* ==========================================================================
   Empório Zem — comportamento da vitrine
   Estático de propósito: cada bloco abaixo marca o ponto onde a versão
   Shopify troca o estado local pelas rotas /cart/*.js. Ver README.
   ========================================================================== */
(function () {
  'use strict';

  var brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- header */
  var header = $('.header');
  if (header) {
    var marcaScroll = function () { header.classList.toggle('is-fixo', window.scrollY > 8); };
    marcaScroll();
    window.addEventListener('scroll', marcaScroll, { passive: true });
  }

  /* ---------------------------------------------------------------- busca */
  var busca = $('[data-busca]');
  if (busca) {
    var campo = $('[data-busca-campo]');
    var abreBusca = function (abrir) {
      busca.hidden = !abrir;
      $$('[data-abre-busca]').forEach(function (b) {
        b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      });
      if (abrir && campo) campo.focus();
    };
    $$('[data-abre-busca]').forEach(function (b) {
      b.addEventListener('click', function () { abreBusca(busca.hidden); });
    });
    $$('[data-fecha-busca]').forEach(function (b) {
      b.addEventListener('click', function () { abreBusca(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !busca.hidden) abreBusca(false);
    });
  }

  /* ------------------------------------------------------------ nav móvel */
  var navmob = $('.navmob');
  if (navmob) {
    var abreNav = function (abrir) {
      navmob.classList.toggle('is-aberto', abrir);
      navmob.setAttribute('aria-hidden', abrir ? 'false' : 'true');
      document.body.style.overflow = abrir ? 'hidden' : '';
      if (abrir) { var a = navmob.querySelector('a'); if (a) a.focus(); }
    };
    $$('[data-abre-nav]').forEach(function (b) { b.addEventListener('click', function () { abreNav(true); }); });
    $$('[data-fecha-nav]').forEach(function (b) { b.addEventListener('click', function () { abreNav(false); }); });
    $$('.navmob__lista a').forEach(function (a) { a.addEventListener('click', function () { abreNav(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navmob.classList.contains('is-aberto')) abreNav(false);
    });
  }

  /* ------------------------------------------------- revelação no scroll */
  var reveláveis = $$('.rev');
  if (reveláveis.length) {
    if (!('IntersectionObserver' in window)) {
      reveláveis.forEach(function (el) { el.classList.add('is-visivel'); });
    } else {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visivel'); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
      reveláveis.forEach(function (el) { obs.observe(el); });
    }
  }

  /* ============================================================= carrinho
     Versão Shopify: o estado é o carrinho da loja, lido e escrito pelas
     rotas /cart/*.js. No site estático isso era localStorage.
     ===================================================================== */
  var carrinho = { items: [], item_count: 0, total_price: 0 };
  var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function dinheiro(centavos) { return brl.format((centavos || 0) / 100); }

  function pintaContagem() {
    /* o brinde por valor não entra na bolinha do carrinho */
    var qtd = (carrinho.items || []).reduce(function (s, i) {
      return s + (ehBrindeValor(i) ? 0 : i.quantity);
    }, 0);
    $$('[data-contagem]').forEach(function (el) {
      el.textContent = qtd;
      el.hidden = qtd === 0;
    });
  }

  /* Preço de comparação por variante, lido de /products/<handle>.js uma vez
     por produto: o /cart.js não traz o compare_at_price. */
  var comparacao = {}, buscando = {};
  /* Produtos sem o riscado do preço de comparação na gaveta. Vazio desde
     14/09: a DrenaFace com 1 unidade também mostra o comparativo da página
     do produto (cliente). */
  var SEM_COMPARACAO = [];

  function cheioDe(i) {
    if (i.original_line_price > i.final_line_price) return i.original_line_price;
    if (SEM_COMPARACAO.indexOf(i.product_id) >= 0) return i.final_line_price;
    var cmp = comparacao[i.variant_id];
    return cmp && cmp * i.quantity > i.final_line_price ? cmp * i.quantity : i.final_line_price;
  }

  function buscaComparacao() {
    var faltam = (carrinho.items || []).filter(function (i) {
      return !(i.variant_id in comparacao) && !buscando[i.handle] && !ehBrinde(i);
    });
    if (!faltam.length) return;
    Promise.all(faltam.map(function (i) {
      buscando[i.handle] = true;
      var guardado = null;
      try { guardado = sessionStorage.getItem('zem-de-' + i.handle); } catch (e) { guardado = null; }
      if (guardado) {
        JSON.parse(guardado).forEach(function (v) { comparacao[v[0]] = v[1]; });
        return Promise.resolve();
      }
      return fetch(RAIZ + 'products/' + i.handle + '.js', { headers: JSON_H })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var pares = (p.variants || []).map(function (v) { return [v.id, v.compare_at_price || 0]; });
          pares.forEach(function (v) { comparacao[v[0]] = v[1]; });
          /* na sessão: da segunda vez a gaveta não faz nem essa chamada */
          try { sessionStorage.setItem('zem-de-' + i.handle, JSON.stringify(pares)); } catch (e) {}
        })
        .catch(function () { comparacao[i.variant_id] = 0; });
    })).then(pintaGaveta);
  }

  /* linha que aparece apagada enquanto a loja responde */
  var pendente = null;

  function pintaGaveta() {
    var lista = $('[data-itens]');
    if (!lista) return;
    var idsOferta = idsOfertaAtuais();
    /* o brinde por valor tem seção própria ("Brindes grátis"), fora desta lista */
    var linhas = (carrinho.items || []).filter(function (i) {
      return idsOferta.indexOf(i.variant_id) === -1 && !ehBrindeValor(i);
    });
    if (pendente && idsOferta.indexOf(pendente.variant_id) === -1) linhas.push(pendente);
    if (!linhas.length) {
      lista.innerHTML = '<div class="gaveta__vazio">'
        + '<p>Seu carrinho está vazio. Comece pelo ritual que faz mais sentido para você hoje.</p>'
        + '<a class="btn btn--carrinho btn--largo" href="' + RAIZ + 'collections/all">VER PRODUTOS</a>'
        + '</div>';
    } else {
      lista.innerHTML = linhas.map(function (i) {
        var cheio = '', cheioL = cheioDe(i);
        if (cheioL > i.final_line_price) {
          var corte = Math.floor((cheioL - i.final_line_price) * 100 / cheioL);
          cheio = '<s>' + dinheiro(cheioL) + '</s>' +
                  '<span class="etiqueta etiqueta--peq">-' + corte + '%</span>';
        }
        return '<article class="item' + (i === pendente ? ' item--pendente' : '') + '">' +
          '<img src="' + (i.image || '') + '" alt="" loading="lazy">' +
          '<div><b>' + i.product_title + '</b>' +
          (i.variant_title ? '<span>' + i.variant_title + '</span>' : '') +
          (ehBrinde(i) || i === pendente
            ? '<span class="item__brinde">' + (i === pendente ? 'Adicionando...' : 'Brinde') + '</span></div>' +
              '<div class="item__preco"><span>' + (i === pendente ? dinheiro(i.final_line_price) : 'Grátis') + '</span></div>'
            : '<div class="item__ctrl">' +
                '<button type="button" data-item-passo="-1" data-chave="' + i.key + '" data-q="' + i.quantity + '" aria-label="Diminuir quantidade">&minus;</button>' +
                '<output aria-live="polite">' + i.quantity + '</output>' +
                '<button type="button" data-item-passo="1" data-chave="' + i.key + '" data-q="' + i.quantity + '" aria-label="Aumentar quantidade">&plus;</button>' +
              '</div>' +
              '<button class="item__remover" data-remove="' + i.key + '" type="button">Remover</button></div>' +
              '<div class="item__preco">' + cheio +
                '<span>' + dinheiro(i.final_line_price) + '</span></div>') +
          '</article>';
      }).join('');
    }
    var elTotal = $('[data-total]');
    if (elTotal) elTotal.textContent = dinheiro(carrinho.total_price);
    var elEco = $('[data-economia]');
    if (elEco) {
      var cheioTotal = (carrinho.items || []).reduce(function (s, i) {
        return s + cheioDe(i);
      }, 0);
      elEco.hidden = cheioTotal <= carrinho.total_price;
      elEco.textContent = 'Você economizou ' +
                          dinheiro(cheioTotal - carrinho.total_price);
    }
    var base = $('[data-gaveta-base]');
    if (base) base.hidden = !linhas.length;
    var temItens = !!(carrinho.items || []).length;
    var timerWrap = $('[data-gaveta-timer]');
    if (timerWrap) timerWrap.hidden = !temItens;
    var tituloProdutos = $('[data-titulo-produtos]');
    if (tituloProdutos) tituloProdutos.hidden = !temItens;
    pintaContagem();
    buscaComparacao();
    pintaOfertas();
    pintaBrindeValor();
  }

  var ofertaOcupada = {};
  function idsOfertaAtuais() {
    return $$('[data-oferta]').map(function (c) {
      return parseInt(c.getAttribute('data-variante-id'), 10);
    });
  }
  function temPrimarioNoCarrinho(itens) {
    var idsOferta = idsOfertaAtuais();
    return (itens || []).some(function (i) {
      return i.quantity > 0 && !ehBrinde(i) && idsOferta.indexOf(i.variant_id) === -1;
    });
  }
  function acertaOfertas(c) {
    var itens = (c && c.items) || [];
    if (temPrimarioNoCarrinho(itens)) return Promise.resolve(c);
    var idsOferta = idsOfertaAtuais();
    var linhasOferta = itens.filter(function (i) {
      return idsOferta.indexOf(i.variant_id) >= 0 && i.quantity > 0;
    });
    if (!linhasOferta.length) return Promise.resolve(c);
    return linhasOferta.reduce(function (p, l) {
      return p.then(function () {
        return fetch(RAIZ + 'cart/change.js', {
          method: 'POST', headers: JSON_H, body: JSON.stringify({ id: l.key, quantity: 0 })
        });
      });
    }, Promise.resolve())
      .then(function () { return fetch(RAIZ + 'cart.js', { headers: JSON_H }); })
      .then(function (r) { return r.json(); })
      .catch(function () { return c; });
  }
  function pintaOfertas() {
    var secao = $('[data-ofertas]');
    var temPrimario = temPrimarioNoCarrinho(carrinho.items);
    if (secao) secao.hidden = !temPrimario;
    if (!temPrimario) return;
    $$('[data-oferta]').forEach(function (card) {
      var id = parseInt(card.getAttribute('data-variante-id'), 10);
      if (ofertaOcupada[id]) return;
      var linha = (carrinho.items || []).filter(function (i) { return i.variant_id === id; })[0];
      var marcada = !!linha;
      card.classList.toggle('marcada', marcada);
      var check = card.querySelector('[data-oferta-check]');
      if (check) check.checked = marcada;
    });
  }

  var gaveta = $('.gaveta');
  var veu = $('.veu');
  function abreGaveta(abrir) {
    if (!gaveta) return;
    gaveta.classList.toggle('is-aberto', abrir);
    gaveta.setAttribute('aria-hidden', abrir ? 'false' : 'true');
    if (veu) veu.classList.toggle('is-aberto', abrir);
    document.body.style.overflow = abrir ? 'hidden' : '';
  }
  $$('[data-abre-carrinho]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); abreGaveta(true); });
  });
  $$('[data-fecha-carrinho]').forEach(function (b) {
    b.addEventListener('click', function () { abreGaveta(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && gaveta && gaveta.classList.contains('is-aberto')) abreGaveta(false);
  });

  var BRINDES = [
    { produto: 8703649448072, variante: 44435751731336 },
    { produto: 8722048778376, variante: 44868511301768 }
  ];

  /* Brinde por valor (09/10): DrenaFace (brinde), produto de R$ 0,00. Entra
     sozinho quando os produtos pagos chegam a "minimo" (em centavos) e sai
     sozinho quando deixam de chegar. Sempre 1 unidade, e só com pelo menos um
     produto de verdade no carrinho (a oferta única não conta como produto,
     mas o valor dela soma no mínimo). Para mudar o valor, é só trocar o
     "minimo" aqui; o texto da barra acompanha. */
  var BRINDE_VALOR = { produto: 15410247303304, variante: 67649349615752, minimo: 40000, nome: 'DrenaFace' };
  function ehBrindeValor(i) { return i.variant_id === BRINDE_VALOR.variante; }

  function ehBrinde(i) {
    return ehBrindeValor(i) || BRINDES.some(function (b) { return b.variante === i.variant_id; });
  }
  function acertaBrindesProduto(c) {
    var itens = (c && c.items) || [], passos = [];
    BRINDES.forEach(function (b) {
      var tem = itens.some(function (i) { return i.product_id === b.produto; });
      var linhas = itens.filter(function (i) { return i.variant_id === b.variante; });
      if (tem && !linhas.length) {
        passos.push(['cart/add.js', { items: [{ id: b.variante, quantity: 1 }] }]);
      }
      linhas.forEach(function (l, n) {
        var quer = tem && n === 0 ? 1 : 0;
        if (l.quantity !== quer) passos.push(['cart/change.js', { id: l.key, quantity: quer }]);
      });
    });
    if (!passos.length) return Promise.resolve(c);
    return passos.reduce(function (p, s) {
      return p.then(function () {
        return fetch(RAIZ + s[0], { method: 'POST', headers: JSON_H, body: JSON.stringify(s[1]) });
      });
    }, Promise.resolve())
      .then(function () { return fetch(RAIZ + 'cart.js', { headers: JSON_H }); })
      .then(function (r) { return r.json(); })
      .then(function (novo) { novo.brindeMudou = true; return novo; })
      .catch(function () { return c; });
  }

  /* quanto o cliente está pagando (sem contar o próprio brinde), em centavos */
  function pagoDoCarrinho(itens) {
    return (itens || []).reduce(function (s, i) {
      return s + (ehBrindeValor(i) ? 0 : i.final_line_price);
    }, 0);
  }
  function brindeValorLiberado(itens) {
    return temPrimarioNoCarrinho(itens) && pagoDoCarrinho(itens) >= BRINDE_VALOR.minimo;
  }
  function acertaBrindeValor(c) {
    var itens = (c && c.items) || [], passos = [];
    var quer = brindeValorLiberado(itens) ? 1 : 0;
    var linhas = itens.filter(function (i) { return ehBrindeValor(i); });
    if (quer && !linhas.length) {
      passos.push(['cart/add.js', { items: [{ id: BRINDE_VALOR.variante, quantity: 1 }] }]);
    }
    linhas.forEach(function (l, n) {
      var q = quer && n === 0 ? 1 : 0;
      if (l.quantity !== q) passos.push(['cart/change.js', { id: l.key, quantity: q }]);
    });
    if (!passos.length) return Promise.resolve(c);
    return passos.reduce(function (p, s) {
      return p.then(function () {
        return fetch(RAIZ + s[0], { method: 'POST', headers: JSON_H, body: JSON.stringify(s[1]) });
      });
    }, Promise.resolve())
      .then(function () { return fetch(RAIZ + 'cart.js', { headers: JSON_H }); })
      .then(function (r) { return r.json(); })
      .then(function (novo) { novo.brindeMudou = true; return novo; })
      .catch(function () { return c; });
  }

  /* os dois tipos de brinde, em sequência; é este que o resto do código chama */
  function acertaBrindes(c) {
    return acertaBrindesProduto(c).then(acertaBrindeValor);
  }

  function pintaBrindeValor() {
    var barra = $('[data-brinde-barra]');
    var secao = $('[data-brindes-gratis]');
    var itens = carrinho.items || [];
    var temPrimario = temPrimarioNoCarrinho(itens);
    var pago = pagoDoCarrinho(itens);
    var ganhou = temPrimario && pago >= BRINDE_VALOR.minimo;
    var linha = itens.filter(function (i) { return ehBrindeValor(i) && i.quantity > 0; })[0];
    var foto = barra ? barra.getAttribute('data-img') : '';

    if (barra) {
      barra.hidden = !temPrimario;
      if (!barra.firstChild) {
        barra.innerHTML =
          '<p class="brinde__txt" data-brinde-txt></p>' +
          '<div class="brinde__linha">' +
            '<div class="brinde__trilho"><span class="brinde__enche" data-brinde-enche></span></div>' +
            '<span class="brinde__marco"><img src="' + foto + '" alt=""></span>' +
          '</div>' +
          '<p class="brinde__rot"><b>' + BRINDE_VALOR.nome + ' Brinde</b><span>' + dinheiro(BRINDE_VALOR.minimo) + '</span></p>';
      }
      if (temPrimario) {
        var falta = Math.max(0, BRINDE_VALOR.minimo - pago);
        var pct = Math.min(100, Math.round(pago * 100 / BRINDE_VALOR.minimo));
        barra.classList.toggle('is-ganho', ganhou);
        barra.querySelector('[data-brinde-txt]').innerHTML = ganhou
          ? 'Você ganhou uma <b>' + BRINDE_VALOR.nome + '</b> de brinde!'
          : 'Faltam <b>' + dinheiro(falta) + '</b> para levar <b>' + BRINDE_VALOR.nome + '</b> brinde';
        barra.querySelector('[data-brinde-enche]').style.width = pct + '%';
      }
    }

    if (secao) {
      secao.hidden = !linha;
      var lista = secao.querySelector('[data-brindes-lista]');
      if (linha && lista) {
        lista.innerHTML = '<article class="item">' +
          '<img src="' + (linha.image || foto) + '" alt="" loading="lazy">' +
          '<div><b>' + BRINDE_VALOR.nome + '</b><span class="item__brinde">Brinde</span></div>' +
          '<div class="item__preco"><span class="brinde__gratis">GRÁTIS</span></div>' +
          '</article>';
      }
    }
  }

  /* Conferência antes do checkout (botão "Finalizar compra"): a Yampi lê o
     /cart.json na hora, então o brinde precisa estar certo neste instante. */
  window.zemConfereBrindes = function () {
    return fetch(RAIZ + 'cart.js', { headers: JSON_H })
      .then(function (r) { return r.json(); })
      .then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) { carrinho = c; pintaGaveta(); })
      .catch(function () { });
  };

  function trocaMioloDoCarrinho() {
    return fetch(window.location.pathname + window.location.search, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('main#conteudo') || doc.querySelector('main');
        var atual = document.querySelector('main#conteudo') || document.querySelector('main');
        if (!novo || !atual) return false;
        atual.innerHTML = novo.innerHTML;
        return true;
      }).catch(function () { return false; });
  }

  function leCarrinho(abrir) {
    return fetch(RAIZ + 'cart.js', { headers: JSON_H })
      .then(function (r) { return r.json(); })
      .then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) {
        carrinho = c; pintaGaveta(); if (abrir) abreGaveta(true);
        if (c.brindeMudou && /\/cart\/?$/.test(window.location.pathname)) {
          trocaMioloDoCarrinho().then(function (ok) { if (!ok) window.location.reload(); });
        }
      })
      .catch(function () { });
  }

  document.addEventListener('click', function (e) {
    var p = e.target.closest ? e.target.closest('[data-item-passo]') : null;
    if (!p) return;
    var q = parseInt(p.getAttribute('data-q'), 10) +
            parseInt(p.getAttribute('data-item-passo'), 10);
    fetch(RAIZ + 'cart/change.js', {
      method: 'POST', headers: JSON_H,
      body: JSON.stringify({ id: p.getAttribute('data-chave'), quantity: Math.max(0, q) })
    }).then(function (r) { return r.json(); })
      .then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) { carrinho = c; pintaGaveta(); });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-remove]') : null;
    if (!b) return;
    fetch(RAIZ + 'cart/change.js', {
      method: 'POST', headers: JSON_H,
      body: JSON.stringify({ id: b.getAttribute('data-remove'), quantity: 0 })
    }).then(function (r) { return r.json(); })
      .then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) { carrinho = c; pintaGaveta(); });
  });

  document.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('[data-oferta]') : null;
    if (!card) return;
    if (e.target.closest('[data-oferta-var]')) return;
    e.preventDefault();
    var id = parseInt(card.getAttribute('data-variante-id'), 10);
    if (!id || ofertaOcupada[id]) return;
    var linhaAtual = (carrinho.items || []).filter(function (i) { return i.variant_id === id; })[0];
    var vaiMarcar = !linhaAtual;

    ofertaOcupada[id] = true;
    card.classList.toggle('marcada', vaiMarcar);
    card.classList.add('is-processando');
    var check = card.querySelector('[data-oferta-check]');
    if (check) check.checked = vaiMarcar;

    var chamada = vaiMarcar
      ? fetch(RAIZ + 'cart/add.js', {
          method: 'POST', headers: JSON_H, body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function () { return fetch(RAIZ + 'cart.js', { headers: JSON_H }); })
      : fetch(RAIZ + 'cart/change.js', {
          method: 'POST', headers: JSON_H, body: JSON.stringify({ id: linhaAtual.key, quantity: 0 })
        });

    chamada.then(function (r) { return r.json(); })
      .then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) {
        carrinho = c;
        delete ofertaOcupada[id];
        card.classList.remove('is-processando');
        pintaGaveta();
        if (!gaveta.classList.contains('is-aberto')) abreGaveta(true);
      })
      .catch(function () {
        delete ofertaOcupada[id];
        card.classList.remove('is-processando');
        leCarrinho(false);
      });
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-oferta-var]') : null;
    if (!sel) return;
    var card = sel.closest('[data-oferta]');
    if (!card) return;
    var oldId = parseInt(card.getAttribute('data-variante-id'), 10);
    var newId = parseInt(sel.value, 10);
    if (!newId || newId === oldId) return;
    var opt = sel.options[sel.selectedIndex];
    var preco = parseInt(opt.getAttribute('data-preco'), 10) || 0;
    var comparado = parseInt(opt.getAttribute('data-comparado'), 10) || 0;
    var imagem = opt.getAttribute('data-imagem');
    card.setAttribute('data-variante-id', newId);
    if (imagem) {
      var foto = card.querySelector('[data-oferta-foto]');
      if (foto) foto.src = imagem;
    }
    var wrap = card.querySelector('[data-oferta-preco-wrap]');
    if (wrap) {
      wrap.innerHTML = (comparado > preco ? '<s data-oferta-comparado>' + dinheiro(comparado) + '</s>' : '') +
        '<strong data-oferta-preco>' + dinheiro(preco) + '</strong>';
    }
    var linhaAtual = (carrinho.items || []).filter(function (i) { return i.variant_id === oldId; })[0];
    if (!linhaAtual) return;
    if (ofertaOcupada[oldId] || ofertaOcupada[newId]) return;
    ofertaOcupada[oldId] = true;
    ofertaOcupada[newId] = true;
    card.classList.add('is-processando');
    fetch(RAIZ + 'cart/change.js', {
      method: 'POST', headers: JSON_H, body: JSON.stringify({ id: linhaAtual.key, quantity: 0 })
    }).then(function () {
      return fetch(RAIZ + 'cart/add.js', {
        method: 'POST', headers: JSON_H, body: JSON.stringify({ id: newId, quantity: 1 })
      });
    }).then(function () { return fetch(RAIZ + 'cart.js', { headers: JSON_H }); })
      .then(function (r) { return r.json(); })
      .then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) {
        carrinho = c;
        delete ofertaOcupada[oldId];
        delete ofertaOcupada[newId];
        card.classList.remove('is-processando');
        pintaGaveta();
      })
      .catch(function () {
        delete ofertaOcupada[oldId];
        delete ofertaOcupada[newId];
        card.classList.remove('is-processando');
        leCarrinho(false);
      });
  });

  function idVariante(item) {
    var sel = document.querySelector('[data-cor][aria-checked="true"]');
    if (sel && sel.getAttribute('data-variante')) return sel.getAttribute('data-variante');
    return String(item.sku).split(':')[0];
  }

  function adiciona(item, depois) {
    var id = parseInt(idVariante(item), 10);
    var qtd = item.qtd || 1;
    var itens = carrinho.items || [];
    var atual = 0;
    itens.forEach(function (i) { if (i.variant_id === id) atual += i.quantity; });

    var updates = {};
    updates[id] = atual + qtd;
    BRINDES.forEach(function (b) {
      var tem = item.produto === b.produto ||
                itens.some(function (i) { return i.product_id === b.produto; });
      var temBrinde = 0;
      itens.forEach(function (i) { if (i.variant_id === b.variante) temBrinde += i.quantity; });
      var quer = tem ? 1 : 0;
      if (temBrinde !== quer) updates[b.variante] = quer;
    });

    if (!depois) {
      pendente = {
        variant_id: id, quantity: qtd, product_title: item.nome || '',
        image: item.img || '', final_line_price: Math.round((item.preco || 0) * 100) * qtd
      };
      pintaGaveta();
      abreGaveta(true);
    }

    return fetch(RAIZ + 'cart/update.js', {
      method: 'POST', headers: JSON_H, body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('update');
      return r.json();
    }).catch(function () {
      return fetch(RAIZ + 'cart/add.js', {
        method: 'POST', headers: JSON_H, body: JSON.stringify({ id: id, quantity: qtd })
      }).then(function () {
        return fetch(RAIZ + 'cart.js', { headers: JSON_H }).then(function (r) { return r.json(); });
      });
    }).then(acertaBrindes)
      .then(acertaOfertas)
      .then(function (c) {
        pendente = null;
        carrinho = c; pintaGaveta();
        if (depois) {
          if (typeof yampiClick === 'function') { yampiClick(); }
          else { window.location.href = RAIZ + 'cart'; }
        }
      })
      .catch(function () { pendente = null; leCarrinho(false); });
  }

  $$('[data-compra-direta]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var pdp = $('[data-produto]');
      if (!pdp) return;
      e.preventDefault();
      var saida = $('[data-qtd]');
      adiciona({ sku: pdp.getAttribute('data-sku'),
                 qtd: saida ? parseInt(saida.value, 10) || 1 : 1 }, true);
    });
  });

  leCarrinho(false);

  function iniciaTimerCarrinho() {
    var el = $('[data-timer]');
    if (!el) return;
    var DURACAO = 10 * 60;
    var CHAVE = 'zem-carrinho-expira';
    var expira = null;
    try { expira = parseInt(sessionStorage.getItem(CHAVE), 10); } catch (e) {}
    if (!expira || isNaN(expira) || expira <= Date.now()) {
      expira = Date.now() + DURACAO * 1000;
      try { sessionStorage.setItem(CHAVE, expira); } catch (e) {}
    }
    var intervalo;
    function pinta() {
      var restam = Math.max(0, Math.round((expira - Date.now()) / 1000));
      var m = Math.floor(restam / 60), s = restam % 60;
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (restam <= 0) clearInterval(intervalo);
    }
    pinta();
    intervalo = setInterval(pinta, 1000);
  }
  iniciaTimerCarrinho();

  var pdp = $('[data-produto]');
  if (pdp) {
    var precoBase = parseFloat(pdp.getAttribute('data-preco'));
    var nomeProd = pdp.getAttribute('data-nome');
    var estado = { variante: null, img: null, qtd: 1 };

    var palco = $('[data-palco]');
    $$('[data-mini]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-mini]').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        btn.setAttribute('aria-selected', 'true');
        if (palco) {
          palco.removeAttribute('srcset');
          palco.src = btn.getAttribute('data-mini');
          palco.alt = btn.getAttribute('data-alt') || '';
        }
      });
    });

    var cores = $$('[data-cor]');
    if (cores.length) {
      var nomeCor = $('[data-cor-nome]');
      var escolhe = function (btn, inicial) {
        cores.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        estado.variante = btn.getAttribute('data-cor');
        estado.img = btn.getAttribute('data-img');
        if (nomeCor) nomeCor.textContent = estado.variante;
        if (palco && estado.img && !inicial) { palco.removeAttribute('srcset'); palco.src = estado.img; }
      };
      cores.forEach(function (btn) {
        btn.addEventListener('click', function () { escolhe(btn); });
        btn.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var i = cores.indexOf(btn);
          var alvo = cores[(i + (e.key === 'ArrowRight' ? 1 : cores.length - 1)) % cores.length];
          alvo.focus(); escolhe(alvo);
        });
      });
      escolhe(cores[0], true);
    }

    var saida = $('[data-qtd]');
    $$('[data-passo]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.getAttribute('data-passo'), 10);
        estado.qtd = Math.min(9, Math.max(1, estado.qtd + d));
        if (saida) saida.value = estado.qtd;
        acendeCombo(estado.qtd);
      });
    });

    var combos = $$('[data-combo]');
    function acendeCombo(q) {
      combos.forEach(function (r) {
        r.checked = (q >= 3 ? r.value === '3' : r.value === String(q));
      });
    }
    combos.forEach(function (r) {
      r.addEventListener('change', function () {
        estado.qtd = parseInt(r.value, 10);
        if (saida) saida.value = estado.qtd;
      });
    });

    $$('[data-adiciona]').forEach(function (btnAdd) {
      btnAdd.addEventListener('click', function () {
        adiciona({
          sku: pdp.getAttribute('data-sku') + (estado.variante ? ':' + estado.variante : ''),
          produto: parseInt(pdp.getAttribute('data-produto-id'), 10) || 0,
          nome: nomeProd,
          variante: estado.variante,
          preco: precoBase,
          precoDe: parseFloat(pdp.getAttribute('data-preco-de')) || 0,
          qtd: estado.qtd,
          img: estado.img || pdp.getAttribute('data-img')
        });
      });
    });

    var traco = $('.capa__traco');
    if (traco && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      traco.classList.add('is-tracando');
    }

    var barra = $('[data-barra]');
    if (barra) {
      barra.hidden = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          barra.classList.toggle('is-visivel', !entradas[0].isIntersecting);
        }, { threshold: 0, rootMargin: '-120px 0px 0px 0px' }).observe(pdp);
      }
    }
  }

  var listaItens = $('[data-itens]');
  if (listaItens) {
    listaItens.addEventListener('click', function (e) {
      var b = e.target.closest('[data-item-passo]');
      if (!b) return;
      var i = carrinho[parseInt(b.getAttribute('data-i'), 10)];
      if (!i) return;
      i.qtd = Math.min(9, i.qtd + parseInt(b.getAttribute('data-item-passo'), 10));
      if (i.qtd < 1) { carrinho.splice(carrinho.indexOf(i), 1); }
      salvaCarrinho();
      pintaGaveta();
    });
  }

  $$('[data-add-rapido]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      adiciona({
        sku: btn.getAttribute('data-sku'),
        produto: parseInt(btn.getAttribute('data-produto-id'), 10) || 0,
        nome: btn.getAttribute('data-nome'),
        variante: null,
        preco: parseFloat(btn.getAttribute('data-preco')),
        precoDe: parseFloat(btn.getAttribute('data-preco-de')) || 0,
        qtd: 1,
        img: btn.getAttribute('data-img')
      });
    });
  });

  var vitrine = $('[data-vitrine]');
  if (vitrine) {
    var slides = $$('[data-slide]', vitrine);
    var pontos = $$('[data-ponto]', vitrine);
    var atual = 0;
    var timer = null;
    var CICLO = parseInt(vitrine.getAttribute('data-ciclo'), 10) || 15000;
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var mostra = function (i) {
      atual = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var ativo = n === atual;
        s.classList.toggle('is-ativo', ativo);
        s.setAttribute('aria-hidden', ativo ? 'false' : 'true');
      });
      pontos.forEach(function (b, n) {
        b.setAttribute('aria-current', n === atual ? 'true' : 'false');
      });
    };

    var anda = function () { mostra(atual + 1); };
    var toca = function () {
      if (quieto || timer) return;
      timer = setInterval(anda, CICLO);
    };
    var para = function () { clearInterval(timer); timer = null; };

    pontos.forEach(function (b, n) {
      b.addEventListener('click', function () { para(); mostra(n); toca(); });
    });

    $$('[data-seta]', vitrine).forEach(function (b) {
      var passo = parseInt(b.getAttribute('data-seta'), 10);
      b.addEventListener('click', function () { para(); mostra(atual + passo); toca(); });
    });

    vitrine.addEventListener('mouseenter', para);
    vitrine.addEventListener('mouseleave', toca);
    vitrine.addEventListener('focusin', para);
    vitrine.addEventListener('focusout', toca);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) para(); else toca();
    });

    toca();
  }

  $$('.acord__botao').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acord__item');
      var aberto = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', aberto ? 'false' : 'true');
      item.classList.toggle('is-aberto', !aberto);
    });
  });

  $$('[data-vip]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var campo = form.querySelector('input[type="email"]');
      if (!campo || !campo.value) return;
      var ok = form.parentNode.querySelector('[data-vip-ok]');
      form.hidden = true;
      if (ok) { ok.hidden = false; ok.textContent = 'Pronto. Enviamos a confirmação para ' + campo.value + '.'; }
    });
  });

  $$('[data-tira]').forEach(function (tira) {
    var trilho = tira.querySelector('[data-tira-trilho]');
    var setas = $$('[data-tira-anda]', tira);
    if (!trilho) return;

    function pinta() {
      var fim = trilho.scrollWidth - trilho.clientWidth - 2;
      setas.forEach(function (b) {
        var pra = parseInt(b.getAttribute('data-tira-anda'), 10);
        b.disabled = pra < 0 ? trilho.scrollLeft <= 2 : trilho.scrollLeft >= fim;
      });
      tira.hidden = trilho.scrollWidth <= trilho.clientWidth + 2 &&
                    trilho.children.length <= 1;
    }
    setas.forEach(function (b) {
      b.addEventListener('click', function () {
        var pra = parseInt(b.getAttribute('data-tira-anda'), 10);
        trilho.scrollBy({ left: pra * trilho.clientWidth * 0.8 });
      });
    });
    trilho.addEventListener('scroll', pinta);
    window.addEventListener('resize', pinta);
    pinta();
  });

  var CICLO_HERO = 6000;
  $$('[data-hero]').forEach(function (hero) {
    var trilho = hero.querySelector('[data-hero-trilho]');
    var pontos = Array.prototype.slice.call(
      hero.querySelectorAll('[data-hero-pontos] button'));
    if (!trilho || pontos.length < 2) return;
    var n = pontos.length, atual = 0, segurando = false, timer = null, fimScroll = null;

    var copia = trilho.children[0].cloneNode(true);
    copia.setAttribute('aria-hidden', 'true');
    copia.setAttribute('tabindex', '-1');
    copia.removeAttribute('data-shopify-editor-block');
    trilho.appendChild(copia);

    function largura() { return trilho.clientWidth || 1; }
    function pinta(i) {
      atual = i;
      pontos.forEach(function (b, j) { b.classList.toggle('is-atual', j === i); });
    }
    function vai(i) { trilho.scrollTo({ left: largura() * i }); }
    function salta(i) {
      trilho.classList.add('is-arrastando');
      trilho.scrollLeft = largura() * i;
      requestAnimationFrame(function () { trilho.classList.remove('is-arrastando'); });
    }
    function anda() {
      if (segurando || document.hidden) return;
      var i = Math.round(trilho.scrollLeft / largura());
      if (i >= n) { salta(0); i = 0; }
      vai(i + 1);
    }
    function relogio() {
      clearInterval(timer);
      timer = setInterval(anda, CICLO_HERO);
    }

    pontos.forEach(function (b, i) {
      b.addEventListener('click', function () { vai(i); relogio(); });
    });
    trilho.addEventListener('scroll', function () {
      var i = Math.round(trilho.scrollLeft / largura());
      pinta(i >= n ? 0 : Math.max(0, i));
      clearTimeout(fimScroll);
      fimScroll = setTimeout(function () {
        if (!segurando && Math.round(trilho.scrollLeft / largura()) >= n) salta(0);
      }, 150);
    }, { passive: true });

    trilho.addEventListener('touchstart', function () { segurando = true; }, { passive: true });
    trilho.addEventListener('touchend', function () { segurando = false; relogio(); }, { passive: true });

    var x0 = 0, s0 = 0, arrastou = false, apertado = false;
    trilho.addEventListener('dragstart', function (e) { e.preventDefault(); });
    trilho.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      apertado = true; segurando = true; arrastou = false;
      x0 = e.clientX; s0 = trilho.scrollLeft;
    });
    trilho.addEventListener('pointermove', function (e) {
      if (!apertado) return;
      var dx = e.clientX - x0;
      if (!arrastou && Math.abs(dx) > 6) {
        arrastou = true;
        trilho.classList.add('is-arrastando');
        trilho.setPointerCapture(e.pointerId);
      }
      if (arrastou) trilho.scrollLeft = s0 - dx;
    });
    function solta(e) {
      if (!apertado) return;
      apertado = false; segurando = false;
      if (arrastou) {
        var dx = e.clientX - x0, base = Math.round(s0 / largura()), alvo = base;
        if (dx < -40) alvo = base + 1;
        else if (dx > 40) alvo = base - 1;
        alvo = Math.max(0, Math.min(n, alvo));
        trilho.classList.remove('is-arrastando');
        vai(alvo);
      }
      relogio();
    }
    trilho.addEventListener('pointerup', solta);
    trilho.addEventListener('pointercancel', solta);
    trilho.addEventListener('click', function (e) {
      if (arrastou) { e.preventDefault(); e.stopPropagation(); arrastou = false; }
    }, true);

    relogio();
  });

  var videosTardios = $$('video[data-tardio]');
  function ligaVideo(v) {
    if (v.getAttribute('data-ligado')) return;
    v.setAttribute('data-ligado', '1');
    $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if (videosTardios.length) {
    if ('IntersectionObserver' in window) {
      var obsVideo = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { ligaVideo(e.target); obsVideo.unobserve(e.target); }
        });
      }, { rootMargin: '400px 0px' });
      videosTardios.forEach(function (v) { obsVideo.observe(v); });
    } else {
      videosTardios.forEach(ligaVideo);
    }
  }

  $$('[data-ano]').forEach(function (el) { el.textContent = new Date().getFullYear(); });
})();
